module.exports = __webpack_public_path__ + "img/order-food.779038f2.png";